import {Testbank} from "@/core/api/room.testbank.api"

export default {
  async resetTestbank({dispatch, commit, state}) {
    commit('SET_VIEW', 'testbank__list');
    commit('SET_TESTBANK');
    commit('SET_TESTBANK_LIST');
    commit('SET_TESTBANK_EXAM');
    commit('SET_TESTBANK_EXAM_LIST');
  },
  async getTestbankList({dispatch, commit, state}, params = {}) {
    params = { ...state.testbankListFilter, ...params }
    const res =  await Testbank.getTestbankList(params);
    commit('SET_TESTBANK_LIST', res);
    return res;
  },
  async createTestbank({dispatch, commit, state, rootGetters}, params) {
    const res = await Testbank.createTestbank(params);
    commit('DELETE_TESTBANK', params);
    await dispatch('getTestbankList', {
      roomId: state.testbankListFilter.inThisRoom ? rootGetters['room/room'].roomId : ''
    });
    return res;
  },
  async deleteTestbank({dispatch, commit, state, rootGetters}, params) {
    const res = await Testbank.deleteTestbank(params);
    await dispatch('getTestbankList', {
      roomId: state.testbankListFilter.inThisRoom ? rootGetters['room/room'].roomId : ''
    });
    return res;
  },
  async getTestbankExamList({dispatch, commit, state}, params = {}) {
    params = { ...state.testbank, ...state.testbankExamListFilter, ...params }
    const res = await Testbank.getTestbankExamList(params);
    commit('SET_TESTBANK', params);
    commit('SET_TESTBANK_EXAM_LIST', res);
    return res;
  },
  async createTestbankExam({dispatch, commit, state}, params) {
    const res = await Testbank.createTestbankExam(params);
    commit('SET_VIEW', 'testbank__exam');
    commit('SET_TESTBANK_EXAM', res);
    return res;
  },
  async getTestbankExam({dispatch, commit, state}, params) {
    params = {
      bankId: state.testbank.bankId,
      bankExamId: state.testbankExam.bankExamId,
      ...params
    }
    let res = await Testbank.getTestbankExam(params);
    if (params.roomExamId) {
      res = { ...res, roomExamId: params.roomExamId };
    }

    commit('SET_TESTBANK_EXAM', res);
    return res;
  },
  async deleteTestbankExam({dispatch, commit, state}, params) {
    params = { bankId: state.testbank.bankId, ...params }
    const res = await Testbank.deleteTestbankExam(params);
    await dispatch('getTestbankExamList');
    return res;
  },
  async editTestbankExam({dispatch, commit, state}, params) {
    const res = await Testbank.editTestbankExam(params);
    commit('SET_VIEW', 'testbank__exam');
    commit('SET_TESTBANK_EXAM', params);
    return res;
  },

  // 출제 이력 목록 조회
  async getTestbankExamHistoryList({dispatch, commit, state}, params) {
    params = { ...state.testbankExamHistoryListFilter, ...params }
    const res = await Testbank.getTestbankExamHistoryList(params);
    commit('SET_TESTBANK_EXAM_HISTORY_LIST', res);
    return res;
  },

  // 출제 이력 상세 조회
  async getTestbankExamHistory({dispatch, commit, state}, params = {}) {
    params = { roomExamId: state.testbankExamHistory.roomExamId, ...params }
    const { roomExamUserList } = await Testbank.getTestbankExamHistory(params);
    const roomExamUserListSortedScore = roomExamUserList.sort((a, b) => b.examScore - a.examScore);

    let testbankExamHistory = state.testbankExamHistoryList.content.find(item => item.roomExamId === params.roomExamId);
    testbankExamHistory = {
      ...testbankExamHistory,
      roomExamUserList: roomExamUserListSortedScore,
    };
    commit('SET_TESTBANK_EXAM_HISTORY', testbankExamHistory);

    return testbankExamHistory;
  },
}
